import React from "react";
import { useParams } from "react-router-dom";
import { ontologyData } from "../../utils/constants";

export default function OntologyPage() {
  const { variable } = useParams();
  const ontology = ontologyData[variable];

  if (!ontology) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-6">
        <p className="text-red-600">Ontology information not available for this variable.</p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-4">
      <h1 className="text-2xl font-semibold mb-2">{ontology.name}</h1>
      <p className="text-gray-600 mb-4">Variable: {variable}</p>
      
      <div className="border rounded-lg p-6 bg-white">
        <h2 className="text-lg font-semibold mb-3">Description</h2>
        <p className="text-gray-700 mb-4">{ontology.description}</p>
        
        <h2 className="text-lg font-semibold mb-3 mt-6">Specifications</h2>
        <dl className="grid grid-cols-2 gap-4">
          <div>
            <dt className="text-gray-500">Units</dt>
            <dd className="font-medium">{ontology.units}</dd>
          </div>
          <div>
            <dt className="text-gray-500">Sensor</dt>
            <dd className="font-medium">{ontology.sensor}</dd>
          </div>
          <div>
            <dt className="text-gray-500">Range</dt>
            <dd className="font-medium">{ontology.range}</dd>
          </div>
          <div>
            <dt className="text-gray-500">Accuracy</dt>
            <dd className="font-medium">{ontology.accuracy}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}